import type { IFollowRepository } from '../../domain/repositories/IFollowRepository.js';
import type { FollowRemoteDataSource } from '../datasources/FollowRemoteDataSource.js';

export class FollowRepository implements IFollowRepository {
  constructor(private readonly remoteDataSource: FollowRemoteDataSource) {}

  listFollowingIds(userId: string): Promise<string[]> {
    return this.remoteDataSource.listFollowingIds(userId);
  }

  listFollowerIds(userId: string): Promise<string[]> {
    return this.remoteDataSource.listFollowerIds(userId);
  }

  follow(followerId: string, followingId: string): Promise<void> {
    return this.remoteDataSource.follow(followerId, followingId);
  }

  unfollow(followerId: string, followingId: string): Promise<void> {
    return this.remoteDataSource.unfollow(followerId, followingId);
  }
}
